import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import '@vaadin/accordion/theme/material/vaadin-accordion.js';
import { elements } from './sdb-elements.js';
/**
 * Heading element, used to display header items for accordion elements (max 4)
 *
 * @slot 1 - the first slot
 * @slot 2 - the second slot
 * @slot 3 - the third slot
 * @slot 4 - the fourth slot
 *
 */
let SDBContentAccordionHeading = class SDBContentAccordionHeading extends LitElement {
    render() {
        return html `
            <slot name="1"></slot>
            <slot name="2"></slot>
            <slot name="3"></slot>
            <slot name="4"></slot>
        `;
    }
};
SDBContentAccordionHeading.styles = [
    elements,
    css `
            :host {
                display: grid;
                grid-auto-columns: 1fr;
                grid-auto-flow: column;
                justify-items: stretch;
                align-items: stretch;
                position: relative;
                padding: 30px var(--sdb-accordionheading-padding-right) 30px
                    var(--sdb-accordionheading-padding-left);
                gap: 0px 15px;
                background: var(
                    --sdb-content-accordionheading-background,
                    white
                );
            }

            :host ::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: var(--sdb-accordionheading-after-left);
                right: 0;
                height: 1px;
                border-top: 1px solid var(--element-lightgrey);
                width: calc(100% - var(--sdb-accordionheading-after-width));
            }
        `,
];
SDBContentAccordionHeading = __decorate([
    customElement('sdb-content-accordionheading')
], SDBContentAccordionHeading);
export { SDBContentAccordionHeading };
//# sourceMappingURL=sdb-content-accordionheading.js.map